import { createAsyncThunk } from '@reduxjs/toolkit';
import request from '../../modules/Request/request';

export const getFeatureParameter = createAsyncThunk(
  'featureParameter',
  async ({
    accountId, isShare, tenantId, accountOrgId,
  }, { rejectWithValue }) => {
    const reqPayload = {};
    const query = {};
    reqPayload.method = 'GET';
    reqPayload.params = [accountId];
    if (isShare) {
      query.isShare = isShare;
      if (accountOrgId) {
        query.accountOrgId = accountOrgId;
      } else {
        query.tenantId = tenantId;
      }
    }
    reqPayload.query = query;
    const response = await request('/feature-parameter', reqPayload);
    if (response.success) {
      return response.data;
    }
    const error = response?.error?.message || response.error;
    throw rejectWithValue(error || 'Something went wrong');
  },
);
